export const packages = [
  {
    id: 1,
    name: 'Normal Wash',
    nameAr: 'غسيل عادي',
    description: 'Basic wash for a clean and fresh vehicle',
    descriptionAr: 'غسيل أساسي لسيارة نظيفة ومنتعشة',
    popular: false,
    prices: {
      sedan: '6',
      suv: '7',
      suv5: '7',
      '7-seater': '8',
    },
    features: [
      'Snow Foam Contact Wash',
      'Hydrophobic Foam Shampoo',
      'Basic Wheel & Tire Cleaning',
      'Wheel Well Water Blast',
      'Door Jamb Blast',
      'High Pressure Rinse',
      'Air Blown & Contact Drying',
      'Door Jamb Wipe',
      'Exterior Glass Clean',
      'Tire Shine',
      'Interior: Basic Vacuum',
      'Dashboard & Center Console Quick Wipe',
      'Interior Glass Clean',
    ],
    featuresAr: [
      'غسيل فوم (رغوة الثلج)',
      'شامبو فوم عازل للماء',
      'تنظيف أساسي للعجلات والإطارات',
      'غسيل المداور بضغط الماء',
      'تنظيف جوانب الأبواب',
      'شطف بضغط ماء عالي',
      'تجفيف بالهواء واللمس',
      'مسح جوانب الأبواب',
      'تنظيف الزجاج الخارجي',
      'تلميع تواير (إطارات)',
      'الداخلية: شفط أتربة أساسي',
      'مسح سريع للطبلون والكونسول',
      'تنظيف الزجاج الداخلي',
    ],
    extras: ['Perfume', 'Floor Mats', 'Tissue Box', 'Trash Bag'],
    extrasAr: ['عطر لسيارة', 'فرشات أرضية', 'علبة مناديل', 'كيس نفايات'],
  },
  {
    id: 2,
    name: 'Shine Wash',
    nameAr: 'غسيل شاين',
    description: 'Enhanced cleaning with detailed trims and interior dressing',
    descriptionAr: 'تنظيف مطور مع تلميع الزوائد والعناية بالديكور الداخلي',
    popular: false,
    prices: {
      sedan: '9',
      suv: '10',
      suv5: '10',
      '7-seater': '11',
    },
    features: [
      'Snow Foam Contact Wash',
      'Hydrophobic Foam Shampoo',
      'Basic Wheel & Tire Cleaning',
      'Wheel Well Water Blast',
      'Door Jamb Blast',
      'High Pressure Rinse',
      'Air Blown & Contact Drying',
      'Door Jamb Wipe',
      'Exterior Glass Clean',
      'Tire Shine',
      'Interior: Basic Vacuum',
      'Dashboard & Center Console Quick Wipe',
      'Interior Glass Clean',
      'Detailed Wheel Water Blast & Brush',
      'Door Jamb Blast & Brush',
      'Tight Area Brush',
      'Spray Sealant Application',
      'Trim Dressing',
      'High Gloss Tire Shine',
      'Interior Quick Wipe & Dressing',
    ],
    featuresAr: [
      'غسيل فوم (رغوة الثلج)',
      'شامبو فوم عازل للماء',
      'تنظيف أساسي للعجلات والإطارات',
      'غسيل المداور بضغط الماء',
      'تنظيف جوانب الأبواب',
      'شطف بضغط ماء عالي',
      'تجفيف بالهواء واللمس',
      'مسح جوانب الأبواب',
      'تنظيف الزجاج الخارجي',
      'تلميع تواير (إطارات)',
      'الداخلية: شفط أتربة أساسي',
      'مسح سريع للطبلون والكونسول',
      'تنظيف الزجاج الداخلي',
      'تنظيف عميق للعجلات بالفرشاة',
      'تنظيف حواف الأبواب بالفرشاة',
      'تنظيف الزوايا الضيقة بالفرشاة',
      'تطبيق مادة سيلنت واقية',
      'تلميع الزوائد الخارجية',
      'تلميع تواير عالي اللمعان',
      'مسح وترطيب الديكور الداخلي',
    ],
    extras: ['Perfume', 'Floor Mats', 'Tissue Box', 'Trash Bag'],
    extrasAr: ['عطر لسيارة', 'فرشات أرضية', 'علبة مناديل', 'كيس نفايات'],
  },
  {
    id: 3,
    name: 'VIP Wash',
    nameAr: 'غسيل VIP',
    description: 'Complete detailing including deep interior and trim care',
    descriptionAr: 'تلميع شامل يشمل التنظيف العميق للداخلية والعناية بالزوائد',
    popular: true,
    prices: {
      sedan: '20',
      suv: '23',
      suv5: '23',
      '7-seater': '25',
    },
    features: [
      'Everything in Shine Wash',
      'Interior APC Wipe',
      'Interior Dressing',
      'Deep Interior Detailing (Seats, Doors, Floor, Roof, Trunk)',
      'Hard Spots Removal',
    ],
    featuresAr: [
      'جميع مميزات غسيل شاين',
      'مسح الداخلية بمواد تنظيف شاملة',
      'ترطيب وحماية الديكور الداخلي',
      'تلميع داخلي عميق (كراسي، أبواب، أرضية، سقف، دبة)',
      'إزالة البقع الصعبة',
    ],
    extras: ['Perfume', 'Floor Mats', 'Tissue Box', 'Trash Bag'],
    extrasAr: ['عطر لسيارة', 'فرشات أرضية', 'علبة مناديل', 'كيس نفايات'],
  },
  {
    id: 4,
    name: 'Royal Wash',
    nameAr: 'غسيل رويال (الملكي)',
    description: 'Ultimate luxury wash with all services and coatings included',
    descriptionAr: 'باقة الفخامة المطلقة تشمل جميع الخدمات مع طبقات الحماية',
    popular: false,
    prices: {
      sedan: '30',
      suv: '33',
      suv5: '33',
      '7-seater': '35',
    },
    features: [
      'Everything in VIP Wash',
      'Detailed Wheel & Tire Cleaning',
      'Wheel Well Water Blast & Brush',
      'Door Jamb Water Blast & Brush',
      'Decontamination',
      '1 Step Polish',
      'Full Trim Dressing',
      'Graphene Spray Coating (2 Layer)',
      'Deep Interior Detailing',
      'All Extras Included',
    ],
    featuresAr: [
      'جميع مميزات غسيل VIP',
      'تنظيف تفصيلي للعجلات والإطارات',
      'غسيل المداور وتفريشها بعمق',
      'غسيل وتفريش حواف الأبواب',
      'إزالة الشوائب (Decontamination)',
      'تلميع صبغ السيارة (مرحلة واحدة)',
      'تلميع وحماية جميع الزوائد',
      'طلاء جرافين بخاخ (طبقتين)',
      'تلميع داخلي عميق وشامل',
      'تشمل جميع الإضافات مجاناً',
    ],
    extras: ['Perfume', 'Floor Mats', 'Tissue Box', 'Trash Bag'],
    extrasAr: ['عطر لسيارة', 'فرشات أرضية', 'علبة مناديل', 'كيس نفايات'],
  },
];
